function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Fill 2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "report-an-issue",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Report-details---report:-describe-issue",
  transform: "translate(-48.000000, -63.000000)",
  fill: "#FFFFFF",
  stroke: "#000000"
}, React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, -30.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(34.000000, 83.000000)"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(8.000000, 0.000000)"
}, React.createElement("path", {
  d: "M9.51162791,19 C9.38165021,19 9.24912392,18.9498231 9.14972921,18.8503199 C8.95009026,18.6504629 8.95009026,18.3289909 9.14972921,18.1291339 L13.76861,13.5018072 L9.14972921,8.87022827 C8.95348837,8.67122176 8.95348837,8.34889924 9.14972921,8.14989273 C9.34851864,7.95003576 9.67388765,7.95003576 9.87267707,8.14989273 L14.8509079,13.1395133 C15.0496974,13.3385198 15.0496974,13.6608423 14.8509079,13.8606993 L9.87267707,18.8503199 C9.77328236,18.9498231 9.64075608,19 9.51162791,19 Z",
  id: "Fill-2",
  transform: "translate(12.000000, 13.500000) rotate(-270.000000) translate(-12.000000, -13.500000) "
}))))));

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down.851e7fdc.svg";
export { ForwardRef as ReactComponent };